 
<template>
  <div class="page-box align-center flex-col">
    <div class="logo-div">
      <img :src="$baseUrl+llll.logo" alt="">
    </div>
    <span class="page-name">{{query_tab==0?'用户登录':(query_tab==1?'会员注册':(query_tab==3?'会员单位登录':'基地登录'))}}</span>
    <div class="login-module justify-center">
      <div class="login-module-form" v-if="query_tab==0">
        <div class="login-module-form-tabs justify-between ">
         <div 
           class="login-module-form-tabs-item"
           v-for="(item,index) in tab_list"
           :key="index"
           :id="`tabs${index}`"
           :class="tab_index == index?'login-module-form-tabs-item-select':''"
           @click="tabsFun(index)"
         >
          {{ item.title }}
          <div class="select-style" :style="{width:tab_index == index?'90%':'0'}"></div></div>
        </div>
       <div class="login-form-box" v-loading="form_loading" element-loading-background="#fff">
        <el-form :model="u_form" :rules="u_rules" ref="u_form" class="demo-ruleForm">
          <el-form-item prop="memberAccount">
            <input v-model="u_form.memberAccount" placeholder="手机号">
          </el-form-item>
          <el-form-item prop="password" v-if="tab_index==0">
            <input v-model="u_form.password" placeholder="密码">
          </el-form-item>
          <el-form-item prop="code" v-if="tab_index==1">
            <div class="login-code-box align-center">
              <input v-model="u_form.code" placeholder="验证码">
              <div 
                class="get-code justify-center align-center" 
                v-loading="code_loading"
                element-loading-spinner="el-icon-loading"
                @click="getCodeFun(u_form.memberAccount)"
              >{{ code_text }}</div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="login-form-btn justify-center align-center" v-loading="login_loading" @click="u_submitForm('u_form',query_tab)">立即登录</div>
          </el-form-item>
          <el-form-item>
           <div class="xieyi-box justify-center f-w">
            没有账号，<span style="color: #819fe9;" @click="jumpLogin(1)">会员注册</span>&nbsp;/&nbsp;<span style="color: #819fe9;" @click="jumpLogin(3)">会员单位注册</span>
           </div>
          </el-form-item>
        </el-form>
       </div>
      </div>
      <div class="login-module-form" v-if="query_tab==1||query_tab==3">
       <div class="login-form-box" style="margin: 0;" v-loading="form_loading" element-loading-background="#fff">
        <zcCom v-if="query_tab==1"/>
        <zcUnitCom v-if="query_tab==3"/>
        <div class="xieyi-box justify-center f-w">
             注册及代表同意<span style="color: #f65b5e;" @click="jumpZcxy()">《注册协议》</span>
           </div>
           <div class="xieyi-box justify-center f-w">
             已有账号，<span style="color: #819fe9;" @click="jumpLogin(0)">立即登录</span>
           </div>
       </div>
      </div>
      <div class="login-module-form" v-if="query_tab==2">
        <div class="login-form-box" style="margin: 0;" v-loading="form_loading" element-loading-background="#fff">
        <el-form :model="g_form" :rules="g_rules" ref="g_form" class="demo-ruleForm">
          <el-form-item prop="username">
            <input v-model="g_form.username" placeholder="账号"/>
          </el-form-item>
          <el-form-item prop="password">
            <input v-model="g_form.password" placeholder="密码"/>
          </el-form-item>
          <el-form-item>
            <div class="login-form-btn justify-center align-center" v-loading="login_loading" @click="g_submitForm('g_form')">立即登录</div>
          </el-form-item>
        </el-form>
       </div>
      </div>
    </div>
  </div>
</template>
<script>
import { loginApi,userloginApi,userRegister,getCode,phoneLogin } from "@/api/g_login";
import zcCom from '../../../components/zc/zc-app.vue'
import zcUnitCom from '../../../components/zc/zc-app-unit.vue'
import { getForm } from "@/api/gwxx";
import { baseUrl } from "@/utils/config";
  export default {
  components:{
    zcCom,
    zcUnitCom
  },
  data() {
    return {
      tab_list:[
        {title:'密码登录'},
        {title:'验证码登录'},
      ],
      tab_index:0,
      tab_width:[0,0],
      code_loading:false,
      code_text:'获取验证码',
      form_loading:false,
      login_loading:false,
      query_tab:0,
      // 基地登录-start
      g_form: {
          username: '',
          password: '',
      },
      g_rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
      // 基地登录-end
      // 用户登录-start
      u_form: {
          memberAccount: '',
          password: '',
          code:''
      },
      u_rules: {
        memberAccount: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      // 用户登录-end
      // 用户注册-start
      ruleForm: {
        memberAccount: '',
        name: '',
        email: '',
        identityCard: '',
        password: '',
        code:''
      },
      rules: {
        memberAccount: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        identityCard: [
            { required: true, message: "请输入身份证号", trigger: "blur" },
            {
              pattern:
                /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: "证件号码格式有误！",
              trigger: "blur",
            },
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      // 用户注册-end
      llll:{}
    };
  },

  mounted() {
    this.query_tab = this.$route.query.tab
    this.getTabWidth()
    getForm().then((res)=>{
      this.llll = JSON.parse(res.data)
    })
  },
  methods: {
    jumpLogin(tab){
      // var userAgent = navigator.userAgent.toLowerCase();
      // if(tab==1&&userAgent.indexOf('micromessenger') !== -1){
      //   window.location.href = this.$baseUrl+'/api/wx/jsPay'
      // }else{
        this.$router.push({ path:'/loginPage',query:{tab} });
        location.reload() 
      // }
    },
    getTabWidth(){
      var element1 = document.getElementById("tabs0");
      var element2 = document.getElementById("tabs1");
      this.tab_width = [element1.offsetWidth,element2.offsetWidth]
      console.log(element1.offsetWidth);
    },
    jumpRouter(path) {
      this.$router.push({ path });
    },
    tabsFun(index){
      this.tab_index = index
      this.form_loading = true
      setTimeout(()=>{
        this.form_loading = false
      },600)
    },
    u_submitRregister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login_loading = true
          userRegister(this.ruleForm).then((res)=>{
            this.$message({message: '注册申请已提交，请耐心等待审核',type: 'success'});
            this.query_tab = 0
            for(let key in this.ruleForm){ this.ruleForm[key] = '' }
          }).finally(()=>{
            this.login_loading = false
          })
        } else {
          return false;
        }
      });
    },
    u_submitForm(formName,tab) {
      console.log("[][][][]",tab);
      localStorage.setItem("tab",tab);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login_loading = true
          if(this.tab_index===0){
            userloginApi({
              memberAccount:this.u_form.memberAccount,
              password:this.u_form.password,
            }).then((res)=>{
              localStorage.setItem("foregroundToken",res.data.token);
              localStorage.setItem("identity",'user');
              this.$message({message: res.message,type: 'success'});
              setTimeout(()=>{
                this.$router.push({ path:'/indexPage',query:{id:1,tab:tab} });
              },1000)
            }).finally(()=>{
              this.login_loading = false
            })
          }else{
            phoneLogin({
              phone:this.u_form.memberAccount,
              code:this.u_form.code,
            }).then((res)=>{
              localStorage.setItem("foregroundToken",res.data.token);
              localStorage.setItem("identity",'user');
              this.$message({message: res.message,type: 'success'});
              setTimeout(()=>{
                this.$router.push({ path:'/indexPage',query:{id:1,tab:tab} });
              },1000)
            }).finally(()=>{
              this.login_loading = false
            })
          }
        } else {
          return false;
        }
      });
    },
    g_submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login_loading = true
          loginApi(this.g_form).then((res)=>{
            localStorage.setItem("foregroundToken",res.data.token);
            localStorage.setItem("identity",'admin');
            this.$message({message: res.message,type: 'success'});
            setTimeout(()=>{
              this.$router.push({ path:'/matrixPage',query:{id:1} });
            },1000)
          }).finally(()=>{
            this.login_loading = false
          })
        } else {
          return false;
        }
      });
    },
    getCodeFun(phone){
      var reg = /^1[3,4,5,6,7,8,9][0-9]{9}$/
      if(!reg.test(phone)){
        this.$message({message: '请输入正确手机号！！！',type: 'error'});
        return
      }
      if(this.code_text.substr(-1)!='s'){
        getCode({phone})
        this.code_loading = true
        let timer
        let code_time = 60
        setTimeout(() => {
          this.code_loading = false
          this.code_text = code_time + ' s'
          timer = setInterval(()=>{
            code_time--
            this.code_text = code_time + ' s'
            if(code_time<1){
              clearInterval(timer)
              this.code_text = '重新获取'
            }
          },1000)
        }, 600);
      }
    },
    jumpZcxy(){
      let pathHerf = this.$router.resolve({
        path:'/agreementPage',query:{name:'注册协议'}
      })
      window.open(pathHerf.href, '_self');
    }
  }
};
</script>
<style scoped lang="css" src="../assets/css/base.css" />
